import React from 'react';

const MailIcon = ({ className }) => (
  <svg
    className={className}
    data-testid="mail-icon"
    width="20"
    height="14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 0H1.25C.56 0 0 .573 0 1.28v11.44C0 13.428.56 14 1.25 14h17.5c.69 0 1.25-.573 1.25-1.28V1.28C20 .572 19.44 0 18.75 0zm-.901 2.456l-7.554 5.997a.63.63 0 01-.37.133.55.55 0 01-.37-.133L2.17 2.436a.615.615 0 01-.09-.86.583.583 0 01.84-.092l7.014 5.72 7.184-5.7a.585.585 0 01.84.113c.2.266.16.655-.11.86v-.02z"
      fill="currentColor"
    />
  </svg>
);

export default MailIcon;
